<div class="invitation-container">
  <div class="invitation-container__header header">
    <div class="intro header__container">
      <h2 class="text-center header__title" [translate]="'invitation.title'"
        data-test="invitation-header"></h2>
      <p class="lead text-center header__desc" [translate]="'invitation.description'"
        data-test="invitation-description">
      </p>
    </div>
  </div>
  <div class="people invitation-container__content content" >
    <ng-container *ngIf="(invitationUrlDetails$ | async) as invitationUrlDetails; else loader">
      <ng-container *ngIf="invitationUrlDetails.shortId; else invitationIdError">
        <div
          class="item content__action-card action-card consumer">
          <div class="action-card__img-container">
            <img src="/assets/images/invitations/consumer.jpg" class="action-card__img">
          </div>

          <div class="action-card__action-body">
            <div class="action-card__action-title" [translate]="'invitation.consumer.title'"
              data-test="consumer-profile-card-header">
            </div>
            <div class="action-card__action-sub-title" [translate]="'invitation.consumer.sub-title'">
            </div>
            <div class="description action-card__action-desc" [translate]="'invitation.consumer.description'"
              data-test="consumer-profile-test-subheader">
            </div>

            <a [href]="invitationUrlDetails.dynamicLink" class="btn btn-primary action-card__button"
              [translate]="'invitation.consumer.button-title'"
              data-test="consumer-profile-card-create"></a>
          </div>
        </div>

        <div
          class="item content__action-card action-card merchant">
          <div class="action-card__img-container">
            <img src="/assets/images/invitations/merchant.jpg" class="action-card__img">
          </div>
          <div class="action-card__action-body">
            <div class="action-card__action-title" [translate]="'invitation.merchant.title'"
            data-test="business-profile-card-header">
            </div>
            <div class="action-card__action-sub-title" [translate]="'invitation.merchant.sub-title'">
            </div>
            <div class="description action-card__action-desc" [translate]="'invitation.merchant.description'"
              data-test="business-profile-card-subheader">
            </div>

            <button (click)="createMerchantProfile(invitationUrlDetails.shortId)" class="btn btn-primary action-card__button"
              [translate]="'invitation.merchant.button-title'" data-test="business-profile-card-create"></button>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #loader>
      <app-loader></app-loader>
    </ng-template>
  </div>
</div>


<ng-template #invitationIdError>
  <div class="alert alert-danger w-100" role="alert">
    <div [translate]="'invitation.error.id-not-found'" data-test="invitation-id-not-found"></div>
  </div>
</ng-template>
